<form name="form" #form="ngForm">
    <div class="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <div class="d-flex align-items-center gap-2 ms-auto">
            @if (!isAdding) {
                @switch (autoSaveStatus) {
                    @case ('saving') {
                        <span class="text-muted small"><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving...</span>
                    }
                    @case ('saved') {
                        <span class="text-success small">Saved</span>
                    }
                    @case ('error') {
                        <span class="text-danger small">Save failed</span>
                    }
                }
            }
            <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
                @if (isSaving) {
                    <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
                } @else {
                    <span>Save</span>
                }
            </button>
            <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
        </div>
    </div>

    <div class="modal-body">
        <div class="row">
            @if (!isAdding) {
                <div class="col-4">
                    <div class="form-group">
                        <label for="createdOn">Created Date</label>
                        <input id="createdOn" type="text" class="form-control" [value]="formatDate(target.createdOn)" readonly />
                    </div>
                </div>
            }

            <div class="col-4">
                <div class="form-group">
                    <label for="dueDate">Due Date</label>
                    <wj-input-date id="dueDate" [(ngModel)]="target.dueDate" name="dueDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>

            <div class="col-4">
                <div class="form-group">
                    <label for="doneDate">Done Date</label>
                    <wj-input-date id="doneDate" [(ngModel)]="target.doneDate" name="doneDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>

            <div class="col-4">
                <div class="form-group">
                    <label for="isArchived">Archived</label>
                    <wj-combo-box
                        id="isArchived"
                        [(ngModel)]="target.isArchived"
                        name="isArchived"
                        [itemsSource]="boolList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-8">
                <div class="form-group">
                    <label for="name">ROCKS Name</label>
                    <input id="name" type="text" class="form-control" [(ngModel)]="target.name" name="name" />
                </div>
            </div>

            <div class="col-4">
                <div class="form-group">
                    <label for="status">Status</label>
                    <wj-combo-box
                        id="status"
                        [(ngModel)]="target.status"
                        name="status"
                        [itemsSource]="statusList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        @if (isAdding) {
            <div class="row">
                <div class="col-8">
                    <div class="form-group">
                        <label for="userId">Who</label>
                        <fa-icon
                            [icon]="faQuestionCircle"
                            style="margin-left: 5px; cursor: pointer"
                            title="When adding a new ROCKS, multiple users can be selected, and a new ROCKS will be created for each user"
                        ></fa-icon>
                        <wj-multi-select
                            id="userId"
                            name="userId"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            [placeholder]="'Select User(s)'"
                            [headerFormat]="'{count:n0} users'"
                            [itemsSource]="userList"
                        >
                        </wj-multi-select>
                    </div>
                </div>

                <div class="col-4">
                    <div class="form-group">
                        <label for="type">Type</label>
                        <wj-combo-box
                            id="type"
                            [(ngModel)]="target.type"
                            name="type"
                            [itemsSource]="typeList"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            </div>
        } @else {
            <div class="row">
                <div class="col-8">
                    <div class="form-group">
                        <label for="userId">Who</label>
                        <wj-combo-box
                            id="userId"
                            [(ngModel)]="target.userId"
                            name="userId"
                            [itemsSource]="userList"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>

                <div class="col-4">
                    <div class="form-group">
                        <label for="type">Type</label>
                        <wj-combo-box
                            id="type"
                            [(ngModel)]="target.type"
                            name="type"
                            [itemsSource]="typeList"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            </div>
        }

        @if (isLeadershipMeeting) {
            <div class="row">
                <div class="col-4">
                    <div class="form-group">
                        <label for="includeInOneYearGoals">Include in 1-Year Goals</label>
                        <wj-combo-box
                            id="includeInOneYearGoals"
                            [(ngModel)]="target.includeInOneYearGoals"
                            name="includeInOneYearGoals"
                            [itemsSource]="boolList"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            [isRequired]="false"
                        ></wj-combo-box>
                    </div>
                </div>
            </div>
        }

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="meetings">Associate With Meeting(s)</label>
                    <wj-multi-select
                        name="meetings"
                        [showFilterInput]="true"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [checkedMemberPath]="'$checked'"
                        [headerFormat]="'{count:n0} items'"
                        [itemsSource]="meetingsList"
                        [placeholder]="'No Meeting Association'"
                    >
                    </wj-multi-select>
                </div>
            </div>
        </div>

        @if (!isAdding && dueDateHistories.length > 0) {
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Due Date History</label>
                        <div class="table-responsive">
                            <table class="table table-sm table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th>Previous Due Date</th>
                                        <th>New Due Date</th>
                                        <th>Changed By</th>
                                        <th>Changed On</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (history of dueDateHistories; track history.id) {
                                        <tr>
                                            <td>{{ formatDate(history.oldDueDate) }}</td>
                                            <td>{{ formatDate(history.newDueDate) }}</td>
                                            <td>{{ history.changedByName || '—' }}</td>
                                            <td>{{ formatDate(history.changedOn) }}</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        }

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="details">Details</label>
                    <quill-editor
                        #quillEditorRef
                        style="width: 100%"
                        [(ngModel)]="target.details"
                        name="details"
                        [styles]="{ height: '200px' }"
                        [modules]="editorModules"
                    >
                    </quill-editor>
                </div>
            </div>
        </div>
    </div>
</form>
